import { mobile } from '@bilibili-maoer/web-utils';
import useWindowSize from 'react-use/lib/useWindowSize';
import { EDeviceType } from '../header/legacy-header/types.js';

var MOBILE_BREAKPOINT = 480; // TODO: 后续迁移至 web-utils 中

var matchMobileWidth = function matchMobileWidth(props) {
  var _ref = props || {},
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? window.innerWidth : _ref$width,
      _ref$breakpoint = _ref.breakpoint,
      breakpoint = _ref$breakpoint === void 0 ? MOBILE_BREAKPOINT : _ref$breakpoint;

  return width <= breakpoint;
}; // TODO: 后续替换掉 web-utils 中 isGeneralMobile 函数

var isGeneralMobile = function isGeneralMobile(props) {
  return mobile.isMobile() || matchMobileWidth(props);
}; // TODO: 后续迁移至 web-utils 中

var useDeviceType = function useDeviceType() {
  var _useWindowSize = useWindowSize(),
      width = _useWindowSize.width;

  if (isGeneralMobile({
    width: width
  })) {
    return EDeviceType.Mobile;
  }

  return EDeviceType.PC;
};

export { isGeneralMobile, matchMobileWidth, useDeviceType };
